export class Background {
    constructor(name, code, backgroundSet, archived = false, thumbnail_200 = "", thumbnail_1200 = "") {
        this.name = name;
        this.code = code;
        this.backgroundSet = backgroundSet;
        this.archived = archived;
        this.thumbnail_200 = thumbnail_200;
        this.thumbnail_1200 = thumbnail_1200;
    }
}
export const backgroundConverter = {
    toFirestore: (background) => {
        return {
            name: background.name,
            code: background.code,
            backgroundSet: background.backgroundSet,
            archived: background.archived,
            thumbnail_200: background.thumbnail_200
        };
    },
    fromFirestore: (snapshot, options) => {
        const data = snapshot.data(options);
        const background = new Background(data.name, data.code, data.backgroundSet, data.archived, data.thumbnail_200);
        background.id = snapshot.id;
        return background;
    }
};
